import React from 'react';
import './EventsMapPage.css';

export { resolveEventsPageView } from './eventsMapRange';

export const EventsMapPage = React.lazy(() => import('./EventsMapPage'));
